import React from 'react'
import More2 from './More2'
import './View2.css';
import Morelist from './Morelist';

const View2 = () => {
  return (
    <div>
    <div className="counter-wrapper45">
    <div className="counter45">
        <h1 className='count45' >PP Woven Sack Bags</h1>
       
        {/* <Button > <a href="/Contact">Contact Us</a></Button> */}
    </div>
   
   
  </div>

  <More2 />
  <Morelist />
 </div>
  )
}

export default View2
